import { render, staticRenderFns } from "./TrangXemNhomChucVu.vue?vue&type=template&id=bfcd450c&"
import script from "./TrangXemNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangXemNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports